import {
	deserializeLocalStorageValue,
	getSessionOidcAuthKey,
	getIssuer,
} from '@shared/utils';

// This file is auto-generated by @hey-api/openapi-ts

import {
	createClient,
	type Options,
	urlSearchParamsBodySerializer,
} from '@hey-api/client-fetch';
import type {
	GetIntrospectionEndpointData,
	GetIntrospectionEndpointError,
	GetIntrospectionEndpointResponse,
	GetLogoutTokenEndpointData,
	GetLogoutTokenEndpointError,
	GetLogoutTokenEndpointResponse,
	GetTokenEndpointData,
	GetTokenEndpointError,
	GetTokenEndpointResponse,
	GetUserInfoEndpointError,
	GetUserInfoEndpointResponse,
} from './types.gen';

/* Manually update for service.gen.ts due to white label usage */
const client = createClient({
	baseUrl: getIssuer(),
	headers: {
		Authorization: `Bearer ${deserializeLocalStorageValue<any>(getSessionOidcAuthKey())?.access_token || ''}`,
	},
});
/**
 * Authorization Endpoint
 */
export const getAuthorizationEndpoint = (options?: Options) => {
	return (options?.client ?? client).get<void>({
		...options,
		url: '/protocol/openid-connect/auth',
	});
};

/**
 * Token Endpoint
 */
export const getTokenEndpoint = (options?: Options<GetTokenEndpointData>) => {
	return (options?.client ?? client).post<
		GetTokenEndpointResponse,
		GetTokenEndpointError
	>({
		...options,
		...urlSearchParamsBodySerializer,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url: '/protocol/openid-connect/token',
	});
};

/**
 * Introspection Endpoint
 */
export const getIntrospectionEndpoint = (
	options?: Options<GetIntrospectionEndpointData>
) => {
	return (options?.client ?? client).post<
		GetIntrospectionEndpointResponse,
		GetIntrospectionEndpointError
	>({
		...options,
		...urlSearchParamsBodySerializer,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url: '/protocol/openid-connect/token/introspect',
	});
};

/**
 * UserInfo Endpoint
 */
export const getUserInfoEndpoint = (options?: Options) => {
	return (options?.client ?? client).get<
		GetUserInfoEndpointResponse,
		GetUserInfoEndpointError
	>({
		...options,
		url: '/protocol/openid-connect/userinfo',
	});
};

/**
 * Logout Token Endpoint
 */
export const getLogoutTokenEndpoint = (
	options?: Options<GetLogoutTokenEndpointData>
) => {
	return (options?.client ?? client).post<
		GetLogoutTokenEndpointResponse,
		GetLogoutTokenEndpointError
	>({
		...options,
		...urlSearchParamsBodySerializer,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url: '/protocol/openid-connect/logout',
	});
};
